export const packetOptions = {
	'pl': {
		1: {
			id: 1,
			title: 'Biuro wirtualne',
			types: [
				{ id: 1, title: 'biuro wirtualne'}
			]
		},
		2: {
			id: 2,
			title: 'Plan otwarty',
			types: [
				{ id: 5, title: 'biurko, plan otwarty, współdzielone/nieprzypisane (hot desk)'},
				{ id: 7, title: 'biurko, plan otwarty, przypisane'},
				{ id: 8, title: 'plan otwarty, dedykowany (część biura do wyłącznego użytku jednej firmy), za biurko'},
			]
		},
		3: {
			id: 3,
			title: 'Pokoje',
			types: [
				{ id: 9, title: 'opłata za miejsce pracy (biurko)'},
				{ id: 10, title: 'pokój 1 osobowy'},
				{ id: 11, title: 'pokój 2 osobowy'},
				{ id: 47, title: 'pokój 3 osobowy'},
				{ id: 12, title: 'pokój 4 osobowy'},
				{ id: 48, title: 'pokój 5 osobowy'},
				{ id: 13, title: 'pokój 6 osobowy'},
				{ id: 49, title: 'pokój 7 osobowy'},
				{ id: 14, title: 'pokój 8 osobowy'},
				{ id: 50, title: 'pokój 9 osobowy'},
				{ id: 15, title: 'pokój 10 osobowy'},
				{ id: 51, title: 'pokój 11 osobowy'},
				{ id: 16, title: 'pokój 12 osobowy'},
				{ id: 52, title: 'pokój 13 osobowy'},
				{ id: 17, title: 'pokój 14-20 osobowy'},
				{ id: 46, title: 'pokój od 21 osób'},
			]
		},
		4: {
			id: 4,
			title: 'Sale konferencyjne',
			types: [
				{ id: 18, title: '2 osobowa'},
				{ id: 19, title: '4 osobowa'},
				{ id: 20, title: '6 osobowa'},
				{ id: 21, title: '8 osobowa'},
				{ id: 22, title: '10 osobowa'},
				{ id: 23, title: '12 osobowa'},
				{ id: 24, title: '14 osobowa'},
				{ id: 25, title: '16 osobowa'},
				{ id: 26, title: '18 osobowa'},
				{ id: 27, title: '20 osobowa'},
				{ id: 28, title: '22 osobowa'},
				{ id: 29, title: '24 osobowa'},
				{ id: 30, title: '26 osobowa'},
				{ id: 31, title: '28 osobowa'},
				{ id: 32, title: '30+ osobowa'},
			]
		},
		5: {
			id: 5,
			title: 'Dodatkowe koszty',
			types: [
				{ id: 33, title: 'Szafka na rzeczy prywatne'},
				{ id: 34, title: 'Udział w wydarzeniach'},
				{ id: 35, title: 'Rejestracja działalności pod adresem centrum'},
				{ id: 36, title: 'Obsługa recepcji'},
				{ id: 37, title: 'Branding'},
				{ id: 38, title: 'Możliwość korzystania z pozostałych lokalizacji operatora'},
				{ id: 39, title: 'Media'},
				{ id: 40, title: 'Internet'},
				{ id: 41, title: 'Wsparcie IT'},
				{ id: 42, title: 'Wydruki czarno-białe'},
				{ id: 43, title: 'Wydruki kolorowe'},
				{ id: 44, title: 'Dostęp do kuchni (kawa, herbata itp.)'},
				{ id: 45, title: 'Sprzątanie biura'},
				{ id: 53, title: 'Miejsce parkingowe'},
			]
		}
	},
	'en': {
		1: {
			id: 1,
			title: 'Virtual office',
			types: [
				{ id: 1, title: 'virtual office'}
			]
		},
		2: {
			id: 2,
			title: 'Open space',
			types: [
				{ id: 5, title: 'desk, open space, shared'},
				{ id: 7, title: 'desk, open space, dedicated'},
				{ id: 8, title: 'open space, dedicated (area close for single company), per FTS'},
			]
		},
		3: {
			id: 3,
			title: 'Work rooms',
			types: [
				{ id: 9, title: 'charge per FTS'},
				{ id: 10, title: 'work room 1 FTS'},
				{ id: 11, title: 'work room 2 FTS'},
				{ id: 47, title: 'work room 3 FTS'},
				{ id: 12, title: 'work room 4 FTS'},
				{ id: 48, title: 'work room 5 FTS'},
				{ id: 13, title: 'work room 6 FTS'},
				{ id: 49, title: 'work room 7 FTS'},
				{ id: 14, title: 'work room 8 FTS'},
				{ id: 50, title: 'work room 9 FTS'},
				{ id: 15, title: 'work room 10 FTS'},
				{ id: 51, title: 'work room 11 FTS'},
				{ id: 16, title: 'work room 12 FTS'},
				{ id: 52, title: 'work room 13 FTS'},
				{ id: 17, title: 'work room 14-20 FTS'},
				{ id: 46, title: 'work room 21+ FTS'},
			]
		},
		4: {
			id: 4,
			title: 'Conference rooms',
			types: [
				{ id: 18, title: 'conference room 2 ppl'},
				{ id: 19, title: 'conference room 4 ppl'},
				{ id: 20, title: 'conference room 6 ppl'},
				{ id: 21, title: 'conference room 8 ppl'},
				{ id: 22, title: 'conference room 10 ppl'},
				{ id: 23, title: 'conference room 12 ppl'},
				{ id: 24, title: 'conference room 14 ppl'},
				{ id: 25, title: 'conference room 16 ppl'},
				{ id: 26, title: 'conference room 18 ppl'},
				{ id: 27, title: 'conference room 20 ppl'},
				{ id: 28, title: 'conference room 22 ppl'},
				{ id: 29, title: 'conference room 24 ppl'},
				{ id: 30, title: 'conference room 26 ppl'},
				{ id: 31, title: 'conference room 28 ppl'},
				{ id: 32, title: 'conference room 30+'},
			]
		},
		5: {
			id: 5,
			title: 'Additional costs',
			types: [
				{ id: 33, title: 'Lockers/storage for private use'},
				{ id: 34, title: 'Events'},
				{ id: 35, title: 'Business registration'},
				{ id: 36, title: 'Reception services'},
				{ id: 37, title: 'Branding'},
				{ id: 38, title: 'Ability to use other location of the operator'},
				{ id: 39, title: 'Media'},
				{ id: 40, title: 'Internet'},
				{ id: 41, title: 'IT support'},
				{ id: 42, title: 'Prints black & white'},
				{ id: 43, title: 'Prints colour'},
				{ id: 44, title: 'Kitchen annex (with tea, coffee etc.) '},
				{ id: 45, title: 'Cleaning service'},
				{ id: 53, title: 'Parking'},
			]
		}
	}
}

export const listOfAmenities = {
	'pl': [
		{ id: 9, title: 'Aneks kuchenny z wyposażeniem' },
		{ id: 25, title: 'Biura w pełni umeblowane' },
		{ id: 32, title: 'Budki / salki do rozmów telefonicznych' },
		{ id: 18, title: 'Dostępność dla osób niepełnosprawnych' },
		{ id: 27, title: 'Ethernet (LAN)' },
		{ id: 3, title: 'Eventy społecznościowe' },
		{ id: 19, title: 'Kawa, herbata i inne napoje' },
		{ id: 31, title: 'Kawiarnia z obsługą baristy' },
		{ id: 7, title: 'Ksero' },
		{ id: 12, title: 'Miejsce przyjazne zwierzętom' },
		{ id: 4, title: 'Obsługa recepcyjna' },
		{ id: 20, title: 'Parking' },
		{ id: 17, title: 'Przestrzeń eventowa' },
		{ id: 1, title: 'Sale konferencyjne' },
		{ id: 22, title: 'Serwis sprzątający' },
		{ id: 21, title: 'Strefa spotkań nieformalnych' },
		{ id: 26, title: 'Telefony IP' },
		{ id: 23, title: 'Usługi kurierskie / pocztowe' },
		{ id: 6, title: 'WiFi' },
	],
	'en': [
		{ id: 31, title: 'Barista coffee point' },
		{ id: 20, title: 'Car park' },
		{ id: 22, title: 'Cleaning service' },
		{ id: 19, title: 'Coffee, tea and beverages' },
		{ id: 1, title: 'Conference rooms' },
		{ id: 23, title: 'Courier / postal services' },
		{ id: 9, title: 'Equipped kitchenette ' },
		{ id: 27, title: 'Ethernet (LAN)' },
		{ id: 17, title: 'Event space' },
		{ id: 25, title: 'Fully furnished offices' },
		{ id: 21, title: 'Informal meeting area' },
		{ id: 26, title: 'IP phones' },
		{ id: 12, title: 'Pet friendly' },
		{ id: 32, title: 'Phone booths / huddle rooms' },
		{ id: 7, title: 'Photocopying' },
		{ id: 4, title: 'Reception services' },
		{ id: 3, title: 'Social events' },
		{ id: 18, title: 'Wheelchair accessibility' },
		{ id: 6, title: 'WiFi' }
	]
}

export const packetPriceCurrencies = [
	{ id: 1, title: 'PLN' },
	{ id: 2, title: 'EUR' }
]

export const packetPriceTypes = [
	{ id: 1, title: 'sq m' },
	{ id: 2, title: 'person' },
	{ id: 3, title: 'office' }
]

export const packetDepositOptions = [
	{ id: 1, title: '1-month rent' },
	{ id: 2, title: '2-months rent ' },
	{ id: 3, title: 'none' }
]

export const officeStatuses = {
	'pl': [
		{ id: 1, title: 'otwarte' },
		{ id: 2, title: 'otwarcie wkrótce' },
	],
	'en': [
		{ id: 1, title: 'open' },
		{ id: 2, title: 'opening soon' },
	]
}

export const officeTypes = {
	'pl': [
		{ id: 1, title: 'biuro serwisowane' },
		{ id: 2, title: 'coworking' },
		{ id: 3, title: 'hybryda' },
	],
	'en': [
		{ id: 1, title: 'serviced office' },
		{ id: 2, title: 'coworking' },
		{ id: 3, title: 'hybrid' },
	]
}

export const enquiryDateTypes = {
	'pl': [
		{ id: '1', title: 'Data' },
		{ id: '2', title: 'Na czas nieokreślony' },
	],
	'en': [
		{ id: '1', title: 'Date' },
		{ id: '2', title: 'Indefinite period of time' },
	]
}


// WEBPACK FOOTER //
// ./src/utils/_DATA.js